module.exports = __webpack_public_path__ + "static/images/team_success_box_title.bf1f635.png";